import reset from "styled-reset";
import { createGlobalStyle } from "./typed-components";

export const GlobalStyles = createGlobalStyle`
  /* @import "~@coreui/coreui/scss/coreui"; */
  @import url('https://fonts.googleapis.com/css?family=Maven+Pro');
  ${reset};
  * {
      box-sizing: border-box;
      ::-webkit-scrollbar {
        width: 2px; /* Remove scrollbar space */
      }
      -ms-overflow-style: none; /* Internet Explorer 10+ */
      scrollbar-width: none;
      /* Optional: show position indicator in red */
      ::-webkit-scrollbar-thumb {
        height: 50%;
        background-color: #C7C7C7;
      }
  }
  body{
    font-family: Inter var,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
    background-color: #f9fafb;
  }
  a{ 
      color:inherit;
      text-decoration:none;
  }
  input,
  button{&:focus,&:active{outline:none}
  button{
    :hover{
      opacity: 0.7;
    }
  }
  }
  h1,h2,h3,h4,h5,h6{
    font-family: Inter var,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;
  }
`;
